var scrollDuration = 300;
var content = $('.js-more-content');
var buttonWrap = $('.js-more-content__button');
var resizeTimer;

var toggleContent = function() {
    buttonWrap.toggleClass('content-hide__button-wrap--more');
    $('.content-hide__wrap').toggleClass('content-hide__wrap--more');
};

var getMaxHeight = function() {
    var maxHeight = $('.content-hide__wrap').data('max-height');

    if (!maxHeight) {
        maxHeight = 320;
    }
    return maxHeight;
};

var getContentHeight = function() {
    return $('.content-hide__inner').outerHeight(true);
};

var bindHideContent = function() {
    buttonWrap.on('click', function(e) {
        e.preventDefault;
        if ($('.content-hide__wrap').hasClass('content-hide__wrap--more')) {
            // Closing
            scrollContent(content);
            setTimeout(
                function() {
                    content.css('maxHeight', getMaxHeight());
                    toggleContent();
                },
                scrollDuration
            );
        } else {
            // Opening
            setTimeout(
                function() {
                    scrollContent(content);
                },
                scrollDuration
            );
            var height = getContentHeight();

            content.css('maxHeight', height);
            toggleContent();
        }

        // todo: set timeout
        scrollContent(content);
    });
};

var bindShowButton = function() {
    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            showButton();
        }, 300);
    });
};

var showButton = function() {
    var height = getContentHeight();

    if (height < getMaxHeight()) {
        buttonWrap.hide();
    } else {
        buttonWrap.show();
    }
};

var scrollContent = function(el) {
    var items = [
        $('.navigation__header'),
        $('.cta-bar'),
        $('#debug-bar'),
        $('#admin-bar')
    ];
    scrollTop = el.offset().top;

    for (var i = 0; i < items.length; i++) {
        if (items[i].length > 0) {
            scrollTop -= items[i].height();
        }
    }

    $('html, body').animate({
        scrollTop: scrollTop - 30
    }, {
        duration: scrollDuration
    });
};

$(function() {
    bindShowButton();
    showButton();
    bindHideContent();
});
